<template>
  <div class="print">
    <el-container>
      <el-main ref="main">
        <div class="printInfo" ref="HTMLPrintContent" id="HTMLPrintContent"
        style="width: 100%;height: 100%;padding: 50px;box-sizing: border-box;overflow-y: auto;">
          <div class="printTitle" style="display: flex;align-items: center;justify-content: center;font-size: 25px;font-weight: 600;">
            <span>青岛路桥建设集团有限公司</span>
            <span>收文处理单</span>
          </div>
          <div class="titleH2" style="width: 794px;margin: 50px auto 0;display: flex;justify-content: space-between;align-items: center;font-size: 16px;font-weight: 600;">
            <div class="titleH2Left" style="display: flex;align-items: center;padding-left: 20px;">
              <div>发文</div>
              <div class="content" style="min-width: 100px;"></div>
              <div>子第</div>
              <div class="content" style="min-width: 100px;"></div>
              <div>号</div>
            </div>
            <div style="display: flex;align-items: center;padding-right: 20px;">
              <span style="min-width: 60px;text-align: center;">
                {{dataForm.createTime.length> 0 ? dataForm.createTime[0]: ''}}
              </span>
              <span>年</span>
              <span style="min-width: 60px;text-align: center;">
                {{dataForm.createTime.length> 0 ? dataForm.createTime[1]: ''}}
              </span>
              <span>月</span>
              <span style="min-width: 60px;text-align: center;">
                {{dataForm.createTime.length> 0 ? dataForm.createTime[2]: ''}}
              </span>
              <span>日</span>
            </div>
          </div>
          <div class="printContent" style="width: 794px;height: 883px;border: 1px solid #DF1717;margin: 20px auto 0;">
            <!--第一行-->
            <div class="firstInfo" style="display: flex;align-items: center;font-size: 18px;">
              <div style="width: 50%;height: 80px;display: flex;align-items: center;border-right: 1px solid #DF1717;border-bottom: 1px solid #DF1717;">
                <div style="width: 30%;height: 100%;padding-left: 5px;box-sizing: border-box;display: flex;align-items: center;border-right: 1px solid #DF1717;">
                  来文单位
                </div>
                <div style="width: 70%;text-align: center;">
                  {{dataForm.documentFromCompany}}
                </div>
              </div>
              <div style="width: 50%;height: 80px;display: flex;align-items: center;border-right: 1px solid #DF1717;border-bottom: 1px solid #DF1717;">
                <div style="width: 30%;height: 100%;padding-left: 5px;box-sizing: border-box;display: flex;align-items: center;border-right: 1px solid #DF1717;">
                  来文字号
                </div>
                <div style="width: 70%;text-align: center;">
                  {{dataForm.documentNum}}
                </div>
              </div>
            </div>
            <!--第二行-->
            <div style="width: 100%;height: 80px;font-size: 18px;display: flex;align-items: center;border-right: 1px solid #DF1717;border-bottom: 1px solid #DF1717;">
              <div class="title" style="width: 15%;height: 100%;padding-left: 5px;box-sizing: border-box;display: flex;align-items: center;border-right: 1px solid #DF1717;">
                文件标题
              </div>
              <div style="width: 85%;text-align: center;">
                {{dataForm.title}}
              </div>
            </div>
            <!--第三行-->
            <div style="width: 100%;height: 250px;padding: 20px;box-sizing: border-box;font-size: 17px;border-bottom: 1px solid #DF1717;">
              <div style="font-weight: 600;">拟办意见：</div>
              <div style=" width: 100%;height: 130px;display: flex;justify-content: center;align-items: center;">
                {{approveUserList.length>=2? approveUserList[approveUserList.length-2].opinion: ''}}
              </div>
              <div style="display: flex;justify-content: flex-end;font-size: 20px;">
                <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;padding-right: 30px;">
                  <div>{{approveUserList.length>=2? approveUserList[approveUserList.length-2].approveUserName: ''}}</div>
                  <div style="padding-top: 10px;">{{approveUserList.length>=2? approveUserList[approveUserList.length-2].updateTime: ''}}</div>
                </div>
              </div>
            </div>
            <!--第四行-->
            <div style="width: 100%;height: 250px;padding: 20px;box-sizing: border-box;font-size: 17px;border-bottom: 1px solid #DF1717;">
              <div style="font-weight: 600;">批办意见：</div>
              <div style=" width: 100%;height: 130px;display: flex;justify-content: center;align-items: center;">
                {{approveUserList.length>0? approveUserList[approveUserList.length-1].opinion: ''}}
              </div>
              <div style="display: flex;justify-content: flex-end;font-size: 20px;">
                <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;padding-right: 30px;">
                  <div>{{approveUserList.length>0? approveUserList[approveUserList.length-1].approveUserName: ''}}</div>
                  <div style="padding-top: 10px;">{{approveUserList.length>0? approveUserList[approveUserList.length-1].updateTime: ''}}</div>
                </div>
              </div>
            </div>
            <!--最后一行-->
            <div style="width: 100%;height: 250px;padding: 20px;box-sizing: border-box;font-size: 17px;">
              <div style="font-weight: 600;">办理情况：</div>
              <div style=" width: 100%;height: 130px;display: flex;justify-content: center;align-items: center;">

              </div>
              <div style="display: flex;justify-content: flex-end;font-size: 20px;">
                <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;padding-right: 30px;">
<!--                  <div>鞠镇业</div>-->
<!--                  <div style="padding-top: 10px;">2022-07-13</div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <el-footer class="container">
        <div class="btnMid">
          <el-button type="info" @click="close()">关闭</el-button>
          <el-button type="info" @click="print()">打印</el-button>
        </div>
      </el-footer>
    </el-container>

    <div class="printWrap" v-show="false">
      <div
          v-html="carriageContent"
          class="mainHtml"
          id="printCarriageContent"
      ></div>
    </div>
  </div>
</template>

<script>
import printJS from "print-js";
import { queryRealApproveProcessApi } from "@/services/sysSettingService";
import {
  getReceiveDetailService,
} from "@/services/documentServices";
export default {
  name: "print",
  data(){
    return {
      carriageContent: "", //富文本编辑器内容
      dataForm:{
        id: '',
        title: '',  // 标题
        documentNum: '',  // 来文字号
        documentFromCompany: '',  // 来文单位
        documentReceiveDate: '',  // 收文日期
        documentDeptJson: [{
          name:''
        }],   //部门数据
        documentDeptId: '', //部门id
        comment: '',  // 拟办意见
        createTime:[],
      },
      approveUserList: [],
    }
  },
  methods: {
    onActive(menuCode) {
      if(this.tabRouteParam.id){
        this.dataForm.id = this.tabRouteParam.id;
        this.getReceiveDetail();
      }
    },
    //获取发文详情
    getReceiveDetail(){
      let paramsData = {
        systemFileExternalId: this.dataForm.id
      }
      getReceiveDetailService(paramsData).then( res => {
        if(res.code == 10000000){
          this.dataForm = {
            id: res.data.id,
            title: res.data.title,  //标题
            documentNum: res.data.documentNum,  // 来文字号
            documentFromCompany: res.data.documentFromCompany,  // 来文单位
            documentReceiveDate: res.data.documentReceiveDate,  // 收文日期
            documentDeptJson: res.data.documentDeptId ? [{
              deptId: res.data.documentDeptId,
              name: res.data.documentDeptName
            }]:[],   //部门数据
            createTime: res.data.createTime.split('-'),
            documentDeptId: res.data.documentDeptId, //部门id
            comment: res.data.comment,  // 拟办意见
          }
          this.queryRealApproveProcess();
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    //获取审批人
    queryRealApproveProcess(){
      let paramsData = {
        itemId: this.dataForm.id,
        approveClass: 'OFFICIAL_DOCUMENT_EXTERNAL',
      }
      queryRealApproveProcessApi(paramsData).then( res => {
        if(res.code == 10000000){
          this.approveUserList = res.data;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 打印按钮
    print(){
      this.$set(
          this,
          "carriageContent",
          this.$refs.HTMLPrintContent.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printCarriageContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
        });
      });
    },
    // 关闭按钮
    close(){
      this.bus.$emit("tabClose", "incomingManagePrint");
      this.bus.$emit("navMenuChange", {
        routeId: "incomingManage"
      });
    },
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/css/commonLayout.scss";
  .print {
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    .container{
      width: 900px;
    }
  }
  /deep/.el-container .el-main{
    height: 100%;
  }
  .btnMid {
    width: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }
  .printInfo{
    width: 100%;
    height: 100%;
    padding: 50px;
    box-sizing: border-box;
    overflow-y: auto;
    .printTitle{
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 25px;
      font-weight: 600;
    }
    .titleH2{
      width: 794px;
      margin: 50px auto 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      .titleH2Left{
        display: flex;
        align-items: center;
        padding-left: 20px;
        .content{
          min-width: 100px;
        }
      }
      .time{
        display: flex;
        align-items: center;
        padding-right: 20px;
        .content{
          min-width: 60px;
          text-align: center;
        }
      }
    }
    .printContent{
      width: 794px;
      height: 1123px;
      border: 1px solid #DF1717;
      margin: 20px auto 0;
      .firstInfo{
        display: flex;
        align-items: center;
        font-size: 18px;
        .firstItem{
          width: 50%;
          height: 80px;
          display: flex;
          align-items: center;
          border-right: 1px solid #DF1717;
          border-bottom: 1px solid #DF1717;
          .title{
            width: 30%;
            height: 100%;
            padding-left: 5px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            border-right: 1px solid #DF1717;
          }
          .content {
            width: 70%;
            text-align: center;
          }
        }
        .firstItem:last-child{
          border-right: 0px;
        }
      }
      .secondInfo{
        width: 100%;
        height: 80px;
        font-size: 18px;
        display: flex;
        align-items: center;
        border-right: 1px solid #DF1717;
        border-bottom: 1px solid #DF1717;
        .title{
          width: 15%;
          height: 100%;
          padding-left: 5px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          border-right: 1px solid #DF1717;
        }
        .content {
          width: 85%;
          text-align: center;
        }
      }
      .threeInfo,.fourthInfo,.lastInfo{
        width: 100%;
        height: 300px;
        padding: 20px;
        box-sizing: border-box;
        font-size: 17px;
        border-bottom: 1px solid #DF1717;
        .title{
          font-weight: 600;
        }
        .content{
          width: 100%;
          height: 180px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .approval{
          display: flex;
          justify-content: flex-end;
          font-size: 20px;
          .info{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-right: 30px;
            .time{
              padding-top: 10px;
            }
          }
        }
      }
      .lastInfo{
        height: 360px;
        border-bottom: 0;
        .content{
          height: 240px;
        }
      }
    }
  }
</style>
